import { CurrencyUtil } from "./CurrencyUtil";
const currencyUtility = new CurrencyUtil([]);
export const init = (currencyConfig) => currencyUtility.set(currencyConfig);
export const currencyUtils = currencyUtility;
//# sourceMappingURL=index.js.map